// extracted by mini-css-extract-plugin
export default {"wrapper":"input-commision_wrapper__NuEUs","disabled":"input-commision_disabled__QVWSE","percent":"input-commision_percent__EEiFh","x":"input-commision_x__ahJkw"};